module.exports = __webpack_public_path__ + "img/ryzs16.c893d0b8.jpg";